<template>
    <span class="text-body-1 pa-0 primary-text-color mb-6 d-flex align-center"> {{ text }} </span>
</template>

<script setup lang="ts">
import { IFormTitle } from '../types';

defineProps<IFormTitle>();
</script>
